export const creditAnalysisStausENUM = {
  AWAITING_APPROVAL: "AWAITING_APPROVAL",
  APPROVED: "APPROVED",
  DISAPPROVED: "DISAPPROVED",
  CANCELLED: "CANCELLED",
};
